import React from 'react';
// @ts-ignore
import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router';
import {useNavigate} from 'react-router-dom';
import { LeftOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import _ from 'lodash';

import {Header} from '../../components/Header/Header';
import Layout from '../../components/Layout/Layout';
import labels from '../../config/labels.json';
import {ILabel} from '../../config/lebels-type';

import cls from './Story.module.scss'

export const ViewerText = () => {

    const navigate = useNavigate()
    const {state} = useLocation();
    const {t} = useTranslation()

    const label = _.filter(labels, (label: ILabel) => label.identifier === state.identifier)[0]?.label;

    return (
        <Layout header={<Header title={t(label)}
                                left={<Button onClick={() => navigate(-1)} size={'small'} shape={'circle'} type={'link'}
                                              icon={<LeftOutlined/>}/>}
                                // right={<Button onClick={() => navigate(-1)} size={'small'} shape={'circle'} type={'link'}
                                //               icon={<DownloadOutlined/>}/>}
        />}
        >
            <div className={cls.wrapper}>

                <pre>
                    {state.description}
                </pre>

            </div>
        </Layout>

    )
}